import React, {Fragment} from 'react';

import WalletTab from "../zenix/MyWallets/WalletTab";
// import CoinChart from "../zenix/MyWallets/CoinChart";
import SwiperSlider2 from "../zenix/MyWallets/SwiperSlider2";
import UpgradeContract from "../zenix/MyWallets/UpgradeContract";
import Approve from "../zenix/MyWallets/Approve";

const Wallet = () => {
	return(
		<Fragment>
			<div className="form-head mb-sm-5 mb-3 d-flex align-items-center flex-wrap">
				<h2 className="font-w600 mb-0 me-auto mb-2 text-black">D-Wallet Token</h2>
				{/*<Link to={"#"} className="btn btn-outline-secondary me-3 mb-2"><i className="las la-calendar scale5 me-2"></i>Filter Periode</Link>*/}
				{/*<Link to={"#"} className="btn btn-outline-secondary mb-2">+ Add Wallet</Link>*/}
			</div>
			<div className="row">
				<div className="col-xl-3 col-xxl-4">
					<div className="swiper-box">
						<SwiperSlider2 />
					</div>
				</div>
				<div className="col-xl-9 col-xxl-8">
					<div className="row">
						<div className="col-xl-12">
							<div className="d-block d-sm-flex mb-4">
								<h4 className="mb-0 text-black fs-20 me-auto">DWT Upgrade Contract</h4>
								<div className="d-flex mt-sm-0">
									{/*<Link to={"#"} className="btn-link me-3 underline">Generate Number</Link>*/}
									{/*<Link to={"#"} className="btn-link underline">Edit</Link>*/}
								</div>
							</div>
						</div>	
						<div className="col-xl-12">
							<UpgradeContract />
						</div>
						{/*<div className="col-xl-12">*/}
						{/*	<CoinChart />*/}
						{/*</div>*/}
					</div>
				</div>
				<div className="col-xl-6  mt-4">
					<div className="row">
						<div className="col-xl-12">
							<WalletTab  activeMenu ="DWT Activity" />
						</div>
					</div>
				</div>
				<div className="col-xl-6 mt-4">
					<div className="row">
						<div className="col-xl-12">
							<Approve />
						</div>
					</div>
				</div>
			</div>
			
			
		</Fragment>
	)
}		
export default Wallet;